export default __webpack_public_path__ + "static/media/Fresnel_Web@2x.522ee582.jpg";